import { IconName } from "@theorgchartdev/storybook";

export type FileIconInfo = {
  iconName: IconName;
  color: string;
  allowColorChange: boolean;
};

export function getFileIconInfo(ext: string): FileIconInfo {
  switch (ext.toLowerCase()) {
    case "oc5m":
      return { iconName: "file-chart-pie", color: "yellow", allowColorChange: true };
    case "ocb":
      return { iconName: "file-chart-pie", color: "dark", allowColorChange: false };
    case "oc5":
      return { iconName: "diagram-project", color: "yellow", allowColorChange: true };
    case "ocd":
      return { iconName: "diagram-project", color: "dark", allowColorChange: false };
    case "csv":
      return { iconName: "file-csv", color: "light-green", allowColorChange: false };
    case "xls":
    case "xlsx":
      return { iconName: "file-excel", color: "light-green", allowColorChange: false };
    case "png":
    case "jpg":
    case "jpeg":
      return { iconName: "file-image", color: "light-blue", allowColorChange: false };
    case "svg":
      return { iconName: "bezier-curve", color: "light-blue", allowColorChange: false };
    case "pdf":
      return { iconName: "file-pdf", color: "light-red", allowColorChange: false };
    case "ppt":
      return { iconName: "file-powerpoint", color: "light-red", allowColorChange: false };
    case "json":
    case "xml":
      return { iconName: "file-code", color: "light-red", allowColorChange: false };
    case "pgp":
    case "txt":
      return { iconName: "file-regular", color: "dark", allowColorChange: false };
    default:
      return { iconName: "file-circle-question", color: "dark", allowColorChange: false };
  }
}
